module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_game_over_scene.724ecddb.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_game_over_scene.json
// module id = 2241
// module chunks = 0